import is from 'is_js'

export const supportedBrowserCheck = () => {
  if (is.ie()) {
    return 'You are using Internet Explorer, which is currently not a supported browser. Some features may not work. Please use Chrome for the best experience.'
  } else {
    return ''
  }
}
